module.exports = "pegasus_template/assets/circle-twitter-old.png";